import styled from "styled-components";

import { options } from "../../style-options";

export const ButtonContainer = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  box-sizing: border-box;
  cursor: pointer;
  background-color: ${({ backgroundColor }) => backgroundColor};
  border-radius: ${({ borderRadius }) => `${borderRadius}px`};
  color: ${({ color }) => color};
  border: 1px solid ${({ border }) => border};
  padding-inline: ${({ size, type }) => options.size[type][size].padding};
  height: ${({ size, type }) => options.size[type][size].height};
  font-size: ${({ size, type }) => options.size[type][size].fontSize};
  flex-flow: ${({ iconPosition }) =>
    options.iconPosition[iconPosition].flexFlow};
  white-space: nowrap;
`;

export const ButtonIconContainer = styled.div`
  display: grid;
  place-content: center;
  width: ${({ size, type }) => options.size[type][size].iconSize};
  height: ${({ size, type }) => options.size[type][size].iconSize};
`;

export const ButtonBlockContainer = styled.div`
  display: grid;
  place-content: ${({ align }) => options.align[align]};
`;

export const Flex = styled.div`
  display: flex;
  align-items: center;
  column-gap: 12px;
`;
